import { MarketingMessage } from './MarketingMessage';
import icon_battery from '../../assets/icon_comfort_empty_state.svg';

export const MarketingMessageThermalZones = () => {
  return (
    <MarketingMessage heading="Thermal Zones" icon={icon_battery} showContact={true}>
      <>
        <p>
          Elexity's HVAC controls are specifically designed for the lite commercial market, and
          deliver the power of a traditional Building Automation System (BAS) at{` `}
          <strong>half the cost</strong>. You gain a "single pane of glass" to remotely monitor and
          control your entire portfolio.
        </p>
        <p>
          You'll also benefit from our adaptive automation, which outsmarts complex utility rates,
          slashing energy bills and demand charges so effectively that the system pays for itself.
          Contact us if you'd like a demo!
        </p>
      </>
    </MarketingMessage>
  );
};
